<template>
        <div class="box">
            <label>{{value.labelText}}<span v-if="required" style="color:#FC1111;">*</span></label>
            <div id="list1" class="dropdown-check-list" :value="value" tabindex="0" v-on:click="onclickEvent($event)"
                 @focusin="onfocusin($event)"
                 @focusout="onfocusout">
                <div class="anchor">{{value.placeholder}}</div>
                <ul class="items">
                    <li v-for="item in value.data" :key="item.id" v-on:click="onClickLi(item,$event)">
                        <BBtnCheckbox :id="item.id" :label-text="item.itemLabel" v-model="item.booleanValue"
                                      :value="item.booleanValue"/>
                    </li>
                </ul>
            </div>
        </div>
</template>

<script>

    import BBtnCheckbox from "./BBtnCheckbox";

    export default {
        name: "BInputPulldownMulti",
        props: {
            value: Object,
            required: Boolean,
        },
        data() {
            return {
                target: null,
            }
        },
        components: {
            BBtnCheckbox,
        },
        methods: {
            onclickEvent(event) {
                var el = event.target.parentElement;
                this.target = el;
                if (el.classList.contains('visible')) {
                    el.classList.remove('visible');
                } else {
                    el.classList.add('visible');
                }
                event.target.parentElement.classList.add("anchorFocus");
            },
            onfocusin(event) {
                var el = event.target;
                this.target = el;
                this.target.classList.add('anchorFocus');
            },
            onfocusout() {
                var el = this.target;
                if (el.classList.contains('visible')) {
                    el.classList.remove('visible');
                }
                el.classList.remove('anchorFocus');
            },
            onClickLi(item, event) {
                event.preventDefault();
                event.stopPropagation();
                if (item.booleanValue === false) {
                    item.booleanValue = true;
                } else {
                    item.booleanValue = false;
                }
            }
        }
    }
</script>

<style scoped>

    :focus {
        outline: none;
    }

    .parent {
        position: relative;
    }

    .box {
        display: flex;
        align-items: center;
    }

    .box label {
        display: inline-block;
        margin-right: 10px;
        color: #333333;
    }

    .dropdown-check-list {
        display: inline-block;
        height: 42px;
        border: 1px solid #DEE2E6;
        border-radius: 5px;
    }

    .dropdown-check-list .anchor {
        cursor: pointer;
        display: flex;
        padding: 0 50px 0 10px;
        width: 220px;
        height: 42px;
        background: url('../assets/arrow.png') 100% / 8% no-repeat;
        background-position: 95% center;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        align-items: center;
    }

    .dropdown-check-list ul.items {
        position: absolute;
        display: none;
        margin: 0;
        background: white;
        width: 220px;
        border: 1px solid #0171A3;
        border-radius: 5px;
        z-index: 8;
    }

    .dropdown-check-list ul.items li {
        list-style: none;
        width: 100%;
        height: 40px;
        padding: 0 10px;
        display: flex;
        align-items: center;
    }

    .dropdown-check-list.visible .anchor {
        /*color: #0094ff;*/
    }

    .dropdown-check-list.visible .items {
        display: block;
    }

    .anchorFocus {
        border: 1px solid #0171A3;
    }
</style>